const GenericHoodContent = () => {
  // We don't have a generic template for hoods
  // so we return null and display no SEO content
  return null
}

export default GenericHoodContent
